<section id="about" >
  <div class="container">


  <header class="section-header">
    <h1 class="section-title" style="text-align: center;">Inventory Management Software</h1>
  </header>
  <div class="row row-eq-height justify-content-center">
      <div class="row about-container">

        
          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
            <div class="icon-box wow fadeInUp">
              <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Item Master </a></h4>
              <p class="description">Creation of Inventory Items, bar code,
                              Customer/Supplier accounts, Manufacturing company, 
                              category, Opening stock, Unit, Warehouse (Creation 
                              and Modification).</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Voucher Entries</a></h4>
              <p class="description">Sales, Purchase, Delivery Challan and GRN Entry
                  Physical Stock, Stock Journal.</p>
            </div>

         

              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Inventory Books</a></h4>
                  <p class="description">Stock Summary,
                      Single Item Stock,
                      Stock Group Summary,
                      Ledger wise Part Transaction,
                      Costing,
                      Daily Part Transaction.</p>
                </div>
                <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Challan Details</a></h4>
                  <p class="description">Sales Delivery Challan,
                      Sales Delivery Challan pending,
                      Purchase Delivery Challan,
                      purchase Delivery Challan pending,
                      Daily Sales Challan Report,
                      Daily Purchase Challan Report.
                    </p>
                </div>
            
              
          </div>
         


          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Inventory Features</a></h4>
                <p class="description">Maintain Batch-Wise Details,
                    Maintain Category-Wise Details,
                    Maintain Multiple Godowns,
                    Maintain Manufacturing Company,
                    Use different Actual & Billed Quantity,
                    Allow Retail / Wholesale Price,
                    Allow Min-Max Level,
                    Allow Reorder Level,
                    Allow -ve stock Entry,
                    Show Stock In Vouchers.
                  </p>
              </div>
  
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Other Features</a></h4>
                  <p class="description">City creation,
                      Tax Percentage setting,
                      Party wise rate setting,
                      Roll and rights creation,
                      User creation.
                     </p>
                </div>
                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Reports</a></h4>
                    <p class="description">Sales Register,
                        Contra Register,
                        Purchase Register,
                        Journal Register,
                        Physical Stock Register,
                        Stock Journal Registe,
                        Inventory Reports.
                      </p>
                  </div>
          </div>
        </div>

        
    </div>
</div>
</section>